import { MotifPagination } from '@ey-xd/motif-react';
import React, { useState } from 'react';

type Column = {
  header: string;
  accessor: string; 
  render?: (data: any) => JSX.Element; 
};

type TableDataItem = {
  [key: string]: any;
};

type AppTableProps = {
  columns: Column[];
  tableData: TableDataItem[];
  rowsPerPage?: number;
};

const AppTable: React.FC<AppTableProps> = ({ columns, tableData, rowsPerPage = 5 }) => {
  const [sortConfig, setSortConfig] = useState<any>({
    key: undefined,
    direction: 'asc',
  });
  const [currentPage, setCurrentPage] = useState(1);

  const handleSort = (accessor: string) => {
    let direction: 'asc' | 'desc' = 'asc';
    if (sortConfig.key === accessor && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: accessor, direction });
  };

  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return tableData;
    return [...tableData].sort((a, b) => {
      const aValue = a[sortConfig.key]?.toString().toLowerCase() ?? '';
      const bValue = b[sortConfig.key]?.toString().toLowerCase() ?? '';
      
      if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [tableData, sortConfig]);
  

  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentPageData = sortedData.slice(startIndex, startIndex + rowsPerPage);

  const handlePageChange = (newPage: any) => {
    setCurrentPage(newPage);
  };

  return (
    <div>
      <table className="w-full text-left">
        <thead className="bg-[#1A1A24] table-header !sticky top-[-1px]" style={{ zIndex: 1 }}>
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                className="border p-4 border-[#2E2E38] cursor-pointer"
                onClick={() => handleSort(column.accessor)}
              >
                {column.header}
                {sortConfig.key === column.accessor && (
                  <span>{sortConfig.direction === 'asc' ? ' ↑' : ' ↓'}</span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentPageData.map((data, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column, colIndex) => (
                <td key={colIndex} className="border cursor-default p-4 border-[#2E2E38]">
                  {column.render ? column.render(data) : data[column.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex pt-4 justify-end">
      <MotifPagination
        allowInput
        currentPage={currentPage}
        itemsPerPage={rowsPerPage}
        max={Math.ceil(tableData.length / rowsPerPage)}
        onPageChange={handlePageChange}
      />
      </div>
    </div>
  );
};

export default AppTable;
